module.exports = __webpack_public_path__ + "media/success.160be12c.mp3";